import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-white rounded-2xl p-6 shadow-2xl max-w-sm w-[90%] animate-popup" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h3 class=\"text-lg font-bold text-gray-800 mb-4 text-center\">Choisissez votre ville</h3><div class=\"flex flex-col gap-3\"><a href=\"https://wa.me/+2290150223847\" target=\"_blank\" class=\"flex items-center gap-3 p-4 bg-[#25D366] hover:bg-[#20bd5a] rounded-xl text-white transition-all\"><i class=\"fa-brands fa-whatsapp text-2xl\"></i><div><span class=\"font-semibold\">Parakou</span><span class=\"block text-sm opacity-90\">+229 01 50 22 38 47</span></div></a><a href=\"https://wa.me/+2290166519432\" target=\"_blank\" class=\"flex items-center gap-3 p-4 bg-[#25D366] hover:bg-[#20bd5a] rounded-xl text-white transition-all\"><i class=\"fa-brands fa-whatsapp text-2xl\"></i><div><span class=\"font-semibold\">Calavi</span><span class=\"block text-sm opacity-90\">+229 01 66 51 94 32</span></div></a></div>", 2)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-whatsapp text-3xl font-bold text-white fa-bounce" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const showWhatsAppPopup = ref(false)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    (showWhatsAppPopup.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black/50 z-[1000000000000001] flex items-center justify-center",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (showWhatsAppPopup.value = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showWhatsAppPopup.value = false)),
              class: "mt-4 w-full py-2 text-gray-500 hover:text-gray-700 text-sm"
            }, " Fermer ")
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (showWhatsAppPopup.value = true)),
      class: "w-[50px] h-[50px] shadow-11xl flex justify-center items-center rounded-[50%] overflow-hidden cursor-pointer fixed right-[25px] bottom-[25px] bg-[#25D366] z-[1000000000000000]"
    }, _hoisted_5)
  ], 64))
}
}

})